module.exports = __webpack_public_path__ + "img/1.59f64278.png";